import $ from 'jquery';

export default class GiftCardStaticSection {
  constructor(section) {
    this.$el = $(section.el);

    this.$qrcode = this.$el.find('[data-qrcode]');
    this._addQRCode();
  }

  onSectionUnload() {
    this.qrcode = null;
  }

  _addQRCode() {
    if (!window.QRCode) return;

    this.qrcode = new QRCode(this.$qrcode[0], {
      text: this.$qrcode.data('qrcode'),
      width: 120,
      height: 120,
    });
  }
}
